import React, { FunctionComponent } from "react";
import { Stack, Flex, Box, Image, StyleProps, GridItem } from "@chakra-ui/react";

import Card from "components/card"
import { SiteConfig_siteConfig_dashboardConf_components } from "graphql/generated";

import { controlReasonHumanLabel } from "../utils";

interface IProps extends StyleProps, BaseCardProps {
  title?: string;
  control?: any;
  image?: string;
  onClick?: () => void;
  isWrappedInside?: boolean;
  highlighted?: boolean;
  icon?: string;
}

export interface BaseCardProps {
  x: number;
  y: number;
  alarmsLink?: string;
}

export interface ICardLabel {
  label: string | null;
  count: number;
}

export const cardLabel = (config: SiteConfig_siteConfig_dashboardConf_components): ICardLabel => {
  const cardLabelOrId = (): string | null => {
    if (config.label !== null) return config.label;
    if (config.id !== null) return config.id;
    return null;
  }

  return {
    label: cardLabelOrId(),
    count: config.grouping ? 2 : 1,
  }
}


const BaseCard: FunctionComponent<IProps> = ({
  x,
  y,
  title,
  control,
  image,
  alarmsLink,
  onClick,
  children,
  highlighted,
  icon,
  isWrappedInside = true,
  ...rest
}) => {

  return <>
    <GridItem w="100%" key={`${x}_${y}`}>
    <Card
      title={title}
      subTitle={control?.reason}
      subTitleTooltip={`${controlReasonHumanLabel(control?.reason)} ${control?.timestamp}`}
      alarmsLink={alarmsLink}
      w={"full"}
      h={230}
      cursor={onClick ? "pointer" : "auto"}
      onClick={onClick}
      highlighted={highlighted}
      icon={icon}
      {...rest}
    >
      {isWrappedInside ? (
        <Stack
          p={4}
          pt={title ? 2 : 4}
          flex={1}
          alignItems={"center"}
          justifyContent={title ? "flex-start" : "center"}
        >
          <Stack direction={"row"} w={"full"}>
            { image && (
              <Box flex={1} minW={"40px"}>
                <Image src={image} boxSize={"130px"} />
              </Box>
            ) }
            <Flex flex={2} alignItems={"center"}>
              {children}
            </Flex>
          </Stack>
        </Stack>
      ) : (
        children
      )}
    </Card>
    </GridItem>
  </>;
}

export default BaseCard;
